import { createSelector } from 'reselect';
import { selectEmployees } from 'modules/SalaryModule/Employees/selectors';
import moment from 'moment';
import { selectFamilyData } from '../../Rewards/selectors';
import { formatNameUpperLastName } from '../../Employees/utils';

export const selectEmployeeRewards = (state) =>
  state.rewardsTableReducer?.employeeRewards?.data?.employeeRewards || [];

export const selectEmployeeRewardsMeta = (state) =>
  state.rewardsTableReducer?.employeeRewards?.meta;

export const selectEmployeeSearch = (state) =>
  state.rewardsTableReducer?.employeeSearch;

export const selectRewardsTableStatus = (state) =>
  state.rewardsTableReducer?.status;

export const selectRewardsActiveMonth = (state) =>
  state.rewardsTableReducer?.activeMonth;

export const selectLastGetEmployeeRewardParams = (state) =>
  state.rewardsTableReducer?.lastGetEmployeeRewardParams;

export const selectGivenRewardsIds = createSelector(
  [selectEmployeeRewards],
  (employeeRewards) =>
    employeeRewards?.reduce((acc, { rewards }) => {
      rewards.forEach(({ companyRewardId, value }) => {
        if (value && !acc.includes(companyRewardId)) {
          acc.push(companyRewardId);
        }
      });
      return acc;
    }, [])
);

export const selectFamilyRewardsTableColumns = createSelector(
  [selectFamilyData],
  (familyData) => {
    if (!familyData || !familyData.companyRewards) {
      return [];
    }

    return familyData.companyRewards.map(
      ({ reward, id, customName, customType }) => ({
        ...reward,
        id,
        name: customName || reward.name,
        type: customType || reward.type,
      })
    );
  }
);

export const selectEmployeeTransformRewards = createSelector(
  [selectEmployeeRewards],
  (employeeRewards) =>
    employeeRewards.map(({ rewards, employee, lastDeclarationPeriod }) => {
      const rewardsObject = rewards.reduce((acc, reward) => {
        acc[reward.companyRewardId] = reward.value;
        return acc;
      }, {});

      return {
        id: employee.id,
        name: formatNameUpperLastName(employee.firstName, employee.lastName),
        lastDeclarationPeriod,
        ...rewardsObject,
      };
    })
);

export const selectEmployeesForReward = createSelector(
  [selectEmployees],
  (employees) =>
    employees
      .filter(
        (employee) =>
          !employee.enddate || moment(employee.enddate).isAfter(moment())
      )
      .map((employee) => ({
        id: employee.employeeid,
        name: formatNameUpperLastName(employee.firstname1, employee.lastname),
      }))
);
